export default "__VITE_ASSET__C_p2E6Ly__"